// The mention dictionary: EVERY username the store knows, as on Apple. Built from the loaded page's
// authors only, a mention of anyone who had not posted on screen — the reader included — drew as
// plain text (the same bug the native apps fixed on 2026-09-04, found again on the web 2026-10-11).
import { useMemo } from 'react';
import { data } from '../../bridge/client';
import { useLive } from '../hooks';

export function useKnownUsernames(pageNames: ReadonlySet<string> | undefined, me: string | null): ReadonlySet<string> {
  const { value: all } = useLive<string[]>(() => data.call('knownUsernames'), ['users'], []);
  return useMemo(() => {
    const names = new Set<string>(all ?? []);
    for (const n of pageNames ?? []) names.add(n);
    if (me) names.add(me);
    return names;
  }, [all, pageNames, me]);
}
